export const CHECKOUT_URL = 'https://pilates-reformer-pret.impultienda.ar/checkout'
